import { targetingApi } from './api';

export const getTargetingInfo = () =>
  targetingApi.get('fetch', {
    relayOn: [
      {
        url: 'save',
        method: 'post',
        baseURL: targetingApi.defaults.baseURL,
      },
      {
        url: 'delete-all',
        method: 'delete',
        baseURL: targetingApi.defaults.baseURL,
      },
    ],
  });

export const saveTargetingInfo = (data) => targetingApi.post('save', data, { important: true });

export const deleteAllTargetingInfo = () => targetingApi.delete('delete-all', { important: true });
